import React from "react";
import styles from "./ProjectCard.module.scss";
import { useParams } from "react-router-dom";

export default function ProjectCard({ project, radius }) {
	const { locale } = useParams();
	console.log(project);
	return (
		<div className={styles.projectCard}>
			<a href={`/${locale}/projects/${project.id}`}>
				<div className={styles.background} style={{ backgroundImage: `url(${project.thumbnail})` }}></div>
				<div className={styles.projectCardContent}>
					<p className={styles.projectCardContentType}>{project.type.title}</p>
					<h3 className={styles.projectCardContentTitle}>{project.title}</h3>
					<p className={styles.projectCardContentBody}>{project.body}</p>
				</div>
			</a>
		</div>
	);
}
